import supabase from "../helpers/init-supabase";

/**
 *
 * @param {object} applicationData - object containing data of the application
 */
export function createApplication(applicationData) {
  return supabase
    .from('applications')
    .insert([applicationData])
    .select()
    .then(resp => {
      if (resp.error) {
        throw resp.error;
      }
      return { data: resp.data[0] };
    })
    .catch(error => ({ error }));
}

/**
 *
 * @param applicationID - ID of the application
 */
export function getApplicationByID(applicationID) {
  return supabase
    .from('applications')
    .select('*')
    .eq('id', applicationID)
    .single()
    .then(resp => {
      if (resp.error) {
        throw resp.error;
      }
      return { data: resp.data };
    })
    .catch(error => ({ error }));
}

/**
 *
 * @param {string} applicationID - Supabase application ID
 * @param {object} newApplicationData - new data for application
 */
export function updateApplication(applicationID, newApplicationData) {
  return supabase
    .from('applications')
    .update(newApplicationData)
    .eq('id', applicationID)
    .select()
    .then(resp => {
      if (resp.error) {
        throw resp.error;
      }
      return { data: resp.data[0] };
    })
    .catch(error => ({ error }));
}

/**
 *
 * @param participantEmail - participant email
 * @param educationFaunaRef - education fauna_id reference
 */
export function getApplicationByParticipant(participantEmail, educationFaunaRef) {
  return supabase
    .from('applications')
    .select('*')
    .eq('participant_email', participantEmail)
    .eq('education_fauna_ref', educationFaunaRef)
    .then(resp => {
      if (resp.error) {
        throw resp.error;
      }
      return { data: resp.data };
    })
    .catch(error => ({ error }));
}

/**
 *
 * @param participantEmail - participant email
 * @param educationType - education type
 * @param attendancyStatus - code of participant's attendancy
 */
export function getApplicationByParticipantForSpecificEducationType(participantEmail, educationType, attendancyStatus) {
  return supabase
    .from('applications')
    .select('*')
    .eq('participant_email', participantEmail)
    .eq('education_type', educationType)
    // Filter by attendance_code if provided
    .then(resp => {
      if (resp.error) {
        throw resp.error;
      }
      // Filter by attendance code on the client side if needed
      let filteredData = resp.data;
      if (attendancyStatus !== undefined && attendancyStatus !== null) {
        filteredData = resp.data.filter(app => 
          app.attendance_code === attendancyStatus.toString()
        );
      }
      return { data: filteredData };
    })
    .catch(error => ({ error }));
}